//Packages
import React, { useContext } from "react";
import { Provider } from "react-redux";

import { Switch, Route, Redirect, useLocation } from "react-router-dom";
//Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Explore from "./pages/Explore";
import Claim from "./pages/Claim";
import Project from "./pages/Project";
import Partners from "./pages/Partners";
import Partner from "./pages/Partner";
import Login from "./pages/Login";
import Join from "./pages/Join";
import Profile from "./pages/Profile";
//Components
import NavBar from "./components/NavBar/index";
import Footer from "./components/Footer/index";
//Animation
import { AnimatePresence } from "framer-motion";
//Context
import { userContext } from "./Context";
import store from "./store";

//Styles
import { ThemeProvider, createTheme } from "@mui/material";

//Material UI Theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#052442",
    },
    secondary: {
      main: "#339CD5",
    },
    neutral: {
      main: "#F1F1F1",
      contrastText: "#052442",
    },
    light: {
      main: "#104D82",
      contrastText: "#FFFFFF",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          width: "fit-content",
          fontWeight: 400,
          fontSize: "13px",
          paddingLeft: 12,
          paddingRight: 12,
          textTransform: "none",
        },
        sizeLarge: {
          lineHeight: "20px",
          fontSize: "18px",
          height: "56px",
          width: "100%",
        },
      },
    },
  },
});

function App() {
  //Obtaining user authentication state
  const { isAuthenticated } = useContext(userContext);

  //Current location from router
  const location = useLocation();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <div className="App">
          <NavBar></NavBar>
          <AnimatePresence exitBeforeEnter>
            {/* React Router */}
            <Switch location={location} key={location.pathname.split("/")[1]}>
              <Route exact path="/">
                <>
                  <Home></Home>
                  <Footer></Footer>
                </>
              </Route>
              <Route exact path="/about">
                <>
                  <About></About>
                  <Footer></Footer>
                </>
              </Route>
              <Route exact path="/explore">
                <>
                  <Explore></Explore>
                  <Footer></Footer>
                </>
              </Route>
              <Route path="/claim/:id">
                <>
                  <Claim></Claim>
                  <Footer></Footer>
                </>
              </Route>
              <Route exact path="/partners">
                <>
                  <Partners></Partners>
                  <Footer></Footer>
                </>
              </Route>
              <Route exact path="/join">
                {isAuthenticated ? (
                  <Redirect to="/" />
                ) : (
                  <>
                    <Join></Join>
                    <Footer></Footer>
                  </>
                )}
              </Route>
              <Route exact path="/login">
                {isAuthenticated ? (
                  <Redirect to="/" />
                ) : (
                  <>
                    <Login></Login>
                    <Footer></Footer>
                  </>
                )}
              </Route>
              <Route path="/project/:id">
                <>
                  <Project></Project>
                  <Footer></Footer>
                </>
              </Route>
              <Route path="/partner/:id">
                <>
                  <Partner></Partner>
                  <Footer></Footer>
                </>
              </Route>
              {!isAuthenticated ? (
                <Redirect to="/login" />
              ) : (
                <>
                  <Route path="/profile">
                    <Profile></Profile>
                  </Route>
                </>
              )}
            </Switch>
          </AnimatePresence>
        </div>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
